/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Gift_Shipping_PrepaidInputs */

const vi_order_gift_shipping_prepaid = /** @type {(inputs: Order_Gift_Shipping_PrepaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thu ship trả trước`)
};

/**

* @param {Order_Gift_Shipping_PrepaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_gift_shipping_prepaid = /** @type {((inputs?: Order_Gift_Shipping_PrepaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Gift_Shipping_PrepaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_gift_shipping_prepaid(inputs)
});